import { render, staticRenderFns } from "./copyLinkToForm.vue?vue&type=template&id=3f9024e7"
import script from "./copyLinkToForm.vue?vue&type=script&lang=js"
export * from "./copyLinkToForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports